const NON_NAVIGATING_PROTOCOLS = ["mailto:", "tel:"];

/**
 * Reports whether following `href` would take the user out of opti.node.
 *
 * `*.node.energy` subdomains (support, go, charge) are separate products, so
 * leaving for one counts as external. `mailto:`/`tel:` don't navigate anywhere,
 * so they never do.
 */
export function isExternalUrl(href: string | undefined): boolean {
  if (!href) {
    return false;
  }

  let parsed: URL;
  try {
    parsed = new URL(href, window.location.origin);
  } catch {
    // Unparseable hrefs are untrusted input — fail closed
    return true;
  }

  if (NON_NAVIGATING_PROTOCOLS.includes(parsed.protocol)) {
    return false;
  }

  return parsed.origin !== window.location.origin;
}
